<template>
  <div style="max-width:900px; margin: auto;">
      <br />
      <h2>Game Stats & Analytics</h2>
   <hr />

   <div class="seasoncast-card">
    <h3>Game Stats</h3>
<hr />
       <p>
        Update your stats in real-time using secondary devices through LockerStats.com or GameBee.io. Obtain the pin by accessing the scoreboard editor on the broadcasting device, or find it by navigating to the event on the dashboard and selecting 'Remote Scoreboard'. Your game stats are promptly updated and reflected on the live broadcast scoreboard. GameBee serves as our previous stat editor, while LockerStats offers comprehensive team stats. Both platforms are free to use. 
           </p>
            <br />
            <a href="https://lockerstats.com" target="_blank" class="btn btn-dark">Go to LockerStats</a>
           <br /> <br />
            <a href="https://gamebee.io" target="_blank" class="btn btn-secondary">Go to GameBee</a>
            
   </div>
   <br />
   <div class="seasoncast-card">
    <h3>Game Film Analytics</h3>
    <hr />

       <p>
        By subscribing to SeasonCast Premium, you receive a complimentary membership to GameTaper Elite. GameTaper.com enables you to perform advanced game analysis on your sporting events, such as highlighting over game film or taking notes.
 <br />
           <br />
           Redeem your free elite membership by clicking 'Connect to SC Premium' on the GameTaper team dashboard after you sign up & create an team. <br /> <br />
           <a href="https://gametaper.com" class="btn btn-success">Go to GameTaper</a>
           </p>
   </div>
   <br />
  
</div>
</template>
<script>
  import cookie from "cookie.js"

export default {
  name: 'GameFilm',
  components: {
    
  },
  data: function () {
    return {
        token: cookie.get("broadcaster-email")
    }
  }
}
  </script>